
import {hex} from "@e280/stz"

export function generateId() {
	return hex.random()
}

